import { render, staticRenderFns } from "./ErrorHero.vue?vue&type=template&id=b20816ae&lang=pug"
import script from "./ErrorHero.vue?vue&type=script&lang=ts"
export * from "./ErrorHero.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports